import { useQuery } from '@apollo/client'
import { Hidden, useMediaQuery, useTheme } from '@material-ui/core'
import Pagination from '@material-ui/lab/Pagination'
import { matchSorter } from 'match-sorter'
import React, { useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'

import { CHANNELS_QUERY } from '../../graphql/channel'
import { Channel } from '../../types/channel'
import ChannelsHeader from './ChannelsHeader'
import { ChannelsTable } from './ChannelsTable'
import { ChannelsTableMobile } from './ChannelsTableMobile'
import useStyles from './styles/index.styles'

const ChannelsList: React.FC = () => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const classes = useStyles()
  const [perPage] = useState(5)
  const [page, setPage] = useState(1)
  const [count, setcount] = useState<number>(0)
  const [searchInputValue, setsearchInputValue] = useState<string>('')
  const { loading, data, refetch } = useQuery<{
    channels: Channel[]
  }>(CHANNELS_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
    variables: {
      showLog: true
    },
    onError: (err) => {
      toast.error(err.message)
    }
  })
  const [filteredChannels, setfilteredChannels] = useState<Channel[]>([])

  useEffect(() => {
    setPage(1)
    const fullChannelsList = data?.channels ? data?.channels : []
    const newFilteredChannelsList = searchInputValue
      ? matchSorter(fullChannelsList, searchInputValue, {
          keys: ['basicDetails.name', 'basicDetails.displayChannelCode']
        })
      : fullChannelsList

    setfilteredChannels(newFilteredChannelsList)
    setcount(newFilteredChannelsList.length)
  }, [searchInputValue, loading])

  const numberOfPages = useMemo(() => Math.ceil(count / perPage), [count])

  return (
    <div>
      <ChannelsHeader
        inputValue={searchInputValue}
        setinputVal={setsearchInputValue}
      />
      <Hidden smDown>
        <ChannelsTable
          data={filteredChannels.slice((page - 1) * perPage, page * perPage)}
          loading={loading}
          reloadData={refetch}
        />
      </Hidden>
      <Hidden mdUp>
        <ChannelsTableMobile
          data={filteredChannels.slice((page - 1) * perPage, page * perPage)}
          loading={loading}
        />
      </Hidden>
      <div className={classes.paginationContainer}>
        <Pagination
          count={numberOfPages}
          color="primary"
          size={isSmallScreen ? 'small' : 'medium'}
          page={page}
          onChange={(_, value) => setPage(value)}
        />
      </div>
    </div>
  )
}

export default ChannelsList
